import { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CurrencySwitcher from '../base/CurrencySwitcher';
import LanguageSwitcher from '../base/LanguageSwitcher';

export default function Navigation() {
  const { t, i18n } = useTranslation(['common']);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: t('nav.home') },
    { path: '/story', label: t('nav.story') },
    { path: '/community', label: t('nav.community') },
    { path: '/student-community', label: 'Student Community', icon: 'ri-graduation-cap-line' },
    { path: '/demands', label: 'Demands', icon: 'ri-megaphone-line' },
    { path: '/blog', label: t('nav.blog') },
    { path: '/health', label: 'Health', icon: 'ri-heart-pulse-line' },
    { path: '/wellness', label: 'Wellness', icon: 'ri-yoga-line' },
    { path: '/shop', label: t('nav.shop') },
    { path: '/digital-shop', label: 'Digital Shop' },
    { path: '/donate', label: t('nav.donate') },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3">
            <span className="text-2xl font-bold bg-gradient-to-r from-pink-600 to-purple-600 bg-clip-text text-transparent">
              SheCan
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2 ${
                  location.pathname === link.path
                    ? 'text-pink-600'
                    : isScrolled
                    ? 'text-gray-700 hover:text-pink-600'
                    : 'text-gray-900 hover:text-pink-600'
                }`}
              >
                {link.icon && <i className={link.icon}></i>}
                {link.path === '/' ? 'Home' : link.label}
              </Link>
            ))}
            <div className="flex items-center gap-3">
              <LanguageSwitcher />
              <CurrencySwitcher />
            </div>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center bg-pink-600 rounded-full cursor-pointer"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-white`}></i>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-4 py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                className={`block text-base font-semibold transition-colors cursor-pointer flex items-center gap-2 ${
                  location.pathname === link.path
                    ? 'text-pink-600'
                    : 'text-gray-700 hover:text-pink-600'
                }`}
              >
                {link.icon && <i className={link.icon}></i>}
                {link.path === '/' ? 'Home' : link.label}
              </Link>
            ))}
            <div className="flex items-center gap-3 pt-4 border-t border-gray-200">
              <LanguageSwitcher />
              <CurrencySwitcher />
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
